import React from 'react';
import axios from 'axios';
import { Button, Popconfirm, Checkbox } from 'antd';
import { Redirect } from 'react-router-dom';

import ACHModalForm from './ACHModalForm';
import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import stickyError from 'components/stickyError';

class ButtonConfirmWrapper extends React.Component {
	render() {
		if (this.props.confirmFirst) {
			return (
				<Popconfirm
					title={this.props.confirmTitle || 'Are you sure?'}
					onConfirm={this.props.onConfirm}>
					{this.props.children}
				</Popconfirm>
			);
		}
		return (
			<span>{this.props.children}</span>
		);
	}
}

export default class PaymentTriggerForm extends React.Component {
	state = {
		redirect: false,
		redirectToRegistered: false,
		processingCredit: false,
		processingACH: false,
		bookingID: null,
		//showACHModal: false,
		//overrideFee: false
	}
	goToPayment = () => {
		// if credit covers charge, go straight to registered
		// if (this.refs.amount.value === '0.00') {
		// 	this.props.refreshBooking().then(booking => {
		// 		this.setState({ processingCredit: false, redirect: true });
		// 	});
		// }
		// if success, direct to payment
		// else {
			const totalAmount = (this.props.childDiscount) ? this.props.total / 2 :	this.props.total;
			axios.post(apiPath+'/vantiv/preauth/'+this.props.orderno_prefix, {
				order_no: this.props.orderno_prefix + this.props.bookingId + '-' + moment().format('x'),
				reference: moment().format('x'),
				ticket: this.props.bookingId,
				amount: parseFloat(Math.round(totalAmount * 100) / 100).toFixed(2),
				//overrideFee: this.state.overrideFee
			}, {withCredentials:true}).then(result => {
				if (result.data.Response.ExpressResponseMessage === 'Success' || result.data.Response.ExpressResponseMessage === 'Approved') {
					const subdomain = (window.location.host.indexOf('portal.semesteratsea.org') !== -1 || window.location.host.indexOf('admin.semesteratsea.org') !== -1) ? 'transaction': 'certtransaction';
					window.location = 'https://'+subdomain+'.hostedpayments.com/?TransactionSetupID='+result.data.Response.Transaction.TransactionSetupID;			
					this.setState({ processingCredit: false  });
				} else {
					stickyError('Failed to initiate transaction');
					this.setState({ processingCredit: false  });
				}
			}).catch(error => {
				console.error(error);
				stickyError("You're session has likely timed out, please log in and try again.");
				this.setState({ processingCredit: false });
			});
		//}
	}
	startCheckout = (paymentMethod) => {
		if (paymentMethod === 'credit/debit') {
			this.props.preCheckout().then(result => {
				this.setState({ processingCredit: true });
				this.goToPayment();
			}).catch(error => {
				console.error(error);
				stickyError(error.message || 'An error occurred, please try again');
				this.setState({ processingCredit: false });
			});
		}
		// if (paymentMethod === 'ACH') {
		// 	this.setState({ showACHModal: true });
		// }
	}
	// handleACHSubmit = (values) => {
	// 	this.setState({
	// 		processingACH: true,
	// 		showACHModal: false
	// 	});
	// 	this.props.preCheckout().then(result => {
	// 		const submitValues = Object.assign({}, values, {
	// 			order_no: this.props.orderno_prefix + this.props.booking.BookingCode + '-' + moment().format('x'),
	// 			reference: moment().format('x'),
	// 			ticket: this.props.booking.BookingId
	// 		});
	// 		axios.post(apiPath+'/vantiv/processACH/'+this.props.orderno_prefix, submitValues, {withCredentials:true})
	// 			.then(result => {
	// 				console.log('process result', result.data);
	// 				const submitRescoValues = Object.assign({}, submitValues, result.data.Response.Transaction);
	// 				axios.post(apiPath+'/vantiv/storeACH/'+this.props.orderno_prefix, submitRescoValues, {withCredentials: true})
	// 					.then(result => {
	// 						this.setState({ processingACH: false });
	// 						this.props.refreshBooking();
	// 						notification.success({
	// 							message: 'Thank you for your payment',
	// 							description: 'We have received your payment and recorded it in the payment status section. It should be fully processed within the next few days.',
	// 							duration: 0
	// 						});
	// 						if (this.props.orderno_prefix === 'FLD') this.setState({ redirectToRegistered: true });
	// 					})
	// 					.catch(error => {
	// 						this.setState({ processingACH: false });
	// 						console.error(error);
	// 						notification.success({
	// 							message: 'Alert',
	// 							description: 'It can take up to 24 hours for your payment to reflect on MyVoyage. Please only submit your payment once.',
	// 							duration: 0
	// 						});
	// 						//stickyError('It can take up to 24 hours for your payment to reflect on MyVoyage. Please only submit your payment once.', true);
	// 					});
	// 			})
	// 			.catch(error => {
	// 				this.setState({ processingACH: false });
	// 				if (error.response.status === 403) return this.props.kickSession('Payment not processed: Your session timed out while the payment was being prepared, please log in and try again');
	// 				console.error(error);
	// 				stickyError('An error occurred while processing your payment, please try again.');
	// 			});
	// 	}).catch(error => {
	// 		console.error(error);
	// 		stickyError(error.message || 'An error occurred, please try again');
	// 		this.setState({ processingACH: false });
	// 	});
	// }
	render() {
		const totalAmount =
			(this.props.childDiscount) ? this.props.total / 2 :
			this.props.total;
		return (
			<div style={{textAlign: 'right'}}>
				{this.state.redirect &&
					<Redirect to={this.props.redirectIfFree} />
				}
				{this.state.redirectToRegistered &&
					<Redirect to={'/portal/field/Registered?clearCart=true'} />
				}

				{this.props.variant === 'admin' && this.props.orderno_prefix === "PRO" && false &&
					<Checkbox value={this.state.overrideFee} onChange={(e) => this.setState({ overrideFee: e.target.checked })}>
						Don't charge 2.7% processing fee
					</Checkbox>
				}

				<ACHModalForm
					total={totalAmount}
					visible={this.state.showACHModal}
					loading={this.state.processingACH}
					onCancel={() => this.setState({ showACHModal: false })}
					onSubmit={this.handleACHSubmit} />

				<input ref="amount" type="hidden" name="amount"
					value={parseFloat(Math.round(totalAmount * 100) / 100).toFixed(2)} />

				{(this.props.total === 0)?
					<ButtonConfirmWrapper
						confirmTitle={this.props.confirmTitle}
						onConfirm={this.props.confirmFirst && this.startCheckout.bind(this, 'credit/debit')}
						onCancel={() => this.setState({ processingCredit: false })}>
						<Button
							className="withSpacing"
							type="primary"
							disabled={this.props.disabled || false}
							size={this.props.buttonSize}
							icon={(this.props.showIcon)?'credit-card':''}
							loading={this.state.processingCredit}
							onClick={(this.props.confirmFirst) ? () => true : this.startCheckout.bind(this, 'credit/debit')}>
							{this.props.buttonText}
						</Button>
					</ButtonConfirmWrapper>
				:
					<div>
						<ButtonConfirmWrapper
							confirmTitle={this.props.confirmTitle}
							onConfirm={this.props.confirmFirst && this.startCheckout.bind(this, 'credit/debit')}
							onCancel={() => this.setState({ processingCredit: false })}>
							<Button
								className="withSpacing"
								type="primary"
								disabled={this.props.disabled || false}
								size={this.props.buttonSize}
								icon={(this.props.showIcon)?'credit-card':''}
								loading={this.state.processingCredit}
								onClick={(this.props.confirmFirst) ? () => true : this.startCheckout.bind(this, 'credit/debit')}>
								{this.props.buttonText+' (credit/debit card)'}
							</Button>
						</ButtonConfirmWrapper>
					</div>
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/PaymentTriggerForm/index.jsx